import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
    allowProps: true,
    theme: {
        dark: false,
        themes: {
            light: {
                primary: '#c20016',
                secondary: '#505045',
                accent: '#fff',
                accent2: '#505045',
                rowQuestion: '#fff',
                rowReply: '#EAE8E0',
                rowDivider: '#d5d2d0',
                error: '#F4511E',
                warning: '#ff9800',
                info: '#1c65d6',
                success: '#66bb6a',
            },
        },
    },
});
